<template>
  <li class="library-cards-item"
      @click="selectEntry(collectionEntry)">
    <router-link class="card-url" :to="{ name: 'collectionEntry', params: { id: collectionEntry.data.id }, query: { filters: this.$route.query.filters } }">
      <div class="image-container" :style="{ backgroundImage: getBgImg(collectionEntry.data.image)}"></div>
      <div class="card-content">
      <h2 class="card-title" :title="collectionEntry.data.title">
        {{ collectionEntry.data.title }}
      </h2>
      <p class="text">
        {{htmlParser(collectionEntry.data.description)}}
      </p>
      <!-- TODO: add type to backend collectionEntry data -->
       <img ref="iconImage" :src="getSrc(collectionEntry)" class="icon" alt="icon">
      </div>
    </router-link>
  </li>
</template>

<script>
import { mapActions } from 'vuex'
import { getCollectionEntryTypeIcon, shouldRotate, htmlParser } from '@/utilityFunctions'
export default {
  name: 'entry-card',
  props: {
    collectionEntry: {
      type: Object,
      required: true
    }
  },
  created () {
    this.$nextTick(function () {
      this.$refs.iconImage.onerror = function () {
        this.src = require('@/assets/images/fileTypeIcons/link_upload.svg')
      }
    })
  },
  computed: {
    shouldRotate
  },
  methods: {
    htmlParser,
    ...mapActions(['selectEntry']),
    // get background image url from collectionEntry obj
    getBgImg (backgroundImage) {
      return `url(${backgroundImage})`
    },
    getSrc (collectionEntry) {
      return getCollectionEntryTypeIcon(collectionEntry)
    }
  }
}
</script>

<style>
</style>
